export enum ProfileType {
  GENERIC = "generic",
  KIDS = "kids",
  PRE_TEENS = "pre-teens",
  TEENS = "teens",
}
